import { memo } from 'react';
import { UploaderSheet } from '@frameio/transfers/components';
import { Box, MenuGroup, SheetHead, Text } from '@frameio/vapor';
import TEXT from './generated/TEXT/UploadsSheet';
import { MenuClearUploadsButton } from './MenuClearUploadsButton';

TEXT.DEFINE({
  /** Sheet title shown at the top of the uploads panel */
  title: 'Uploads',
});

export const UploadsSheet = memo(() => {
  return (
    <>
      <SheetHead
        contextMenuContent={
          <MenuGroup>
            <MenuClearUploadsButton />
          </MenuGroup>
        }
        title={
          <Text
            aria-level={2}
            color="inherit"
            display="inline"
            role="heading"
            variant="link"
          >
            {TEXT.title}
          </Text>
        }
      />
      <Box flexGrow="1" overflow="hidden" position="relative">
        <UploaderSheet />
      </Box>
    </>
  );
});
